<template>
  <div>
    <template v-if="_.trim(opportunityId) === ''">
      <pre
           style="font-size: 14px;font-family: Arial,-apple-system,BlinkMacSystemFont,&quot;Segoe UI&quot;,Roboto,&quot;Helvetica Neue&quot;,&quot;Noto Sans&quot;,&quot;Liberation Sans&quot;,sans-serif,&quot;Apple Color Emoji&quot;,&quot;Segoe UI Emoji&quot;,&quot;Segoe UI Symbol&quot;,&quot;Noto Color Emoji&quot;;
      ">{{ opportunityName }}</pre>
    </template>
    <template v-else>
      <a class="link" target="_blank" :href="safeUrl(`${ $root.salesforceUrl }/${ opportunityId }`)">
        <pre style="font-size: 14px; margin-top:1rem; font-family: Arial,-apple-system,BlinkMacSystemFont,&quot;Segoe UI&quot;,Roboto,&quot;Helvetica Neue&quot;,&quot;Noto Sans&quot;,&quot;Liberation Sans&quot;,sans-serif,&quot;Apple Color Emoji&quot;,&quot;Segoe UI Emoji&quot;,&quot;Segoe UI Symbol&quot;,&quot;Noto Color Emoji&quot;;
      ">{{ opportunityName }}</pre>
      </a>
    </template>
  </div>
</template>
<script>
import { safeUrl } from '@/helpers/vue-url';
  export default {
    name: 'gtc-opportunity',
    props: ['opportunityId', 'opportunityName']
  }
</script>



// WEBPACK FOOTER //
// src/components/framework/GtcOpportunityInventory.vue